import { Stack } from "@mui/material";
import AcxButton from "components/UI/AcxButton";
import AcxMainTextField from "components/UI/AcxMainTextField";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import React, { useState } from "react";
import { AcxMessageBox as MessageBox } from "components/UI/AcxMessageBox";

const origin = window.location.origin;

export default function ForgotPassword() {
    const [username, setUsername] = useState("");
    const [isInvalidUsername, setIsInvalidUsername] = useState(false);
    const [hasSentRequest, setHasSentRequest] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const sendReset = async () => {
        try {
            setIsLoading(true);
            await fetch(`api/Authenticate/ResetPasswordRequest`, {
                method: "Post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    UserName: username,
                    ChangePasswordUrl: `${origin}/changepassword`,
                }),
            });

            setHasSentRequest(true);
        } catch (error) {
            console.log(error);
        }
        setIsLoading(false);
    };

    const handleReset = () => {
        setIsInvalidUsername(!username);
        if (username) {
            sendReset();
        }
    };

    const handleKeyPress = (event: React.KeyboardEvent) => {
        if (event.key === "Enter") {
            event.preventDefault();
            handleReset();
        }
    };

    const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newUsername = e.target.value;
        setUsername(newUsername);
        if (isInvalidUsername && newUsername) {
            setIsInvalidUsername(false);
        }
    };

    return (
        <Stack onKeyDown={handleKeyPress} component="form" sx={{ gap: 1 }}>
            <AcxMainTextField
                labelText="Username"
                labelSx={(theme) => ({
                    fontSize: "14px",

                    "&.Mui-focused": {
                        color: theme.palette.gray[700],
                        fontWeight: 400,
                    },
                })}
                id="login-username"
                type="text"
                fullWidth
                value={username}
                onChange={handleUsernameChange}
                placeholderText="Enter your username"
                textContainerSx={{ maxHeight: "36px" }}
            />
            {hasSentRequest && (
                <MessageBox
                    sx={{ mt: 1.5 }}
                    icon={
                        <CheckCircleRoundedIcon
                            sx={(theme) => ({
                                color: theme.palette.primary[700],
                            })}
                        />
                    }
                >
                    If an account exists with that username, you'll receive an
                    email with a link to reset your password shortly.
                </MessageBox>
            )}
            {isInvalidUsername && (
                <MessageBox sx={{ mt: 1.5 }} variant="error">
                    Username is required.
                </MessageBox>
            )}
            <AcxButton
                fullWidth
                color="primary"
                onClick={handleReset}
                sx={{
                    height: "36px",
                    mt: 1.5,
                }}
                loading={isLoading}
            >
                Reset my password
            </AcxButton>
        </Stack>
    );
}
